// extracted by mini-css-extract-plugin
export default {"textWrapper":"Home_textWrapper__8AEaV","heading":"Home_heading__aDvjE","text":"Home_text__o5uF7","locationImage":"Home_locationImage__lsPWq"};